import { ReactNode, useEffect, useState } from "react";
import { Flex, Text } from "rebass/styled-components";
import styled from "styled-components";

import { analytics } from "MVVM/Analytics";

interface ITab {
  component: ReactNode;
  name: string;
  title: string;
  type: string;
}

interface ITabsProps {
  active?: number;
  tabs: ITab[];
  color?: string;
  onTabChange?: (index: number) => void;
}

const Tabs = ({ active, tabs, color, onTabChange }: ITabsProps) => {
  const [activeTab, setActiveTab] = useState(active || 0);

  const updateTabParam = (newTabValue: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set("tab", newTabValue);
    window.history.pushState({}, "", url);
  };

  useEffect(() => {
    setActiveTab(active || 0);
  }, [active]);

  return (
    <Flex>
      {tabs.length > 1 &&
        tabs.map((tab, index) => (
          <Tab
            key={tab.title}
            active={activeTab === index}
            onClick={() => {
              setActiveTab(index);
              analytics.track("Tab Clicked", { type: tab.type });
              updateTabParam(tab.name);
              onTabChange?.(index);
            }}
            flex="1 1 0"
            color={color}
          >
            <Text variant="text.labelSmall">{tab.title}</Text>
          </Tab>
        ))}
    </Flex>
  );
};

const Tab = styled(Flex)<{ active: boolean; color?: string }>`
  border-bottom: ${(props) =>
    props.active
      ? `2px solid ${props.color || props.theme.colors.envy}`
      : `2px solid ${props.theme.colors.navy}`};
  color: ${(props) =>
    props.active
      ? props.color || props.theme.colors.envy
      : props.theme.colors.chalk};
  cursor: pointer;
  font-weight: 500;
  justify-content: center;
  padding: 0 0 12px 0;
`;

export { Tabs };
